"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
/**Vista por default para los errores de componentToRx */
var ErrorView = /** @class */ (function (_super) {
    __extends(ErrorView, _super);
    function ErrorView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorView.prototype.render = function () {
        return (React.createElement("span", { style: { color: "red" } }, this.props.errores.map(function (x, i) {
            return React.createElement("span", { key: i },
                "Error al obtener ",
                React.createElement("span", { style: { fontWeight: "bold" } }, x.prop),
                ": ",
                React.createElement("span", { style: { fontStyle: "italic" } }, "" + x.error));
        })));
    };
    return ErrorView;
}(React.PureComponent));
exports.ErrorView = ErrorView;
//# sourceMappingURL=error.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-rxk/dist/error.js
// module id = 2506
// module chunks = 0